let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aDgIB")).then(() => parcelRequire('3K1px'));